module.exports = __webpack_public_path__ + "media/images/vr/reservas-header-d09f7109f54ed8e034db9cf589b37345.jpg";